// Day keys of the v2 timings JSON (plan 01-schema §3.1), in the order the page lists them.
export const WEEK_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const SHIFT_STATUS_LABELS = {
  active: "Active",
  draft: "Draft",
  disabled: "Disabled",
};

// A missing or empty day has no restriction and no generated slots (decision N9).
export const OPEN_DAY_LABEL = "Open";
export const TIMINGS_UNAVAILABLE_LABEL = "Timings unavailable";

// What the API's `source` says when the shift table, not the hardcoded constants, decides (A5).
export const SHIFT_SOURCE_V2 = "v2";

export const DAY_OPTIONS = [
  { key: "monday", label: "Mon" },
  { key: "tuesday", label: "Tue" },
  { key: "wednesday", label: "Wed" },
  { key: "thursday", label: "Thu" },
  { key: "friday", label: "Fri" },
  { key: "saturday", label: "Sat" },
  { key: "sunday", label: "Sun" },
];

export const TIME_STEP_MINUTES = 30;

export const FORM_MODE = { ADD: "add", EDIT: "edit" };

export const FLEX_MODE = { FIXED: "fixed", MIN: "min", OPEN: "open" };
